if (ht.CentralExchange) {
  $('#CentralSessionInit').each(function () {
    if (navigator.cookieEnabled != false) {
      var opts = $(this).metadata().CentralSessionManagerOpts;
      ht.CentralSessionManager.init(opts);
    }
  });
}
